/// <reference path="../typings/index.d.ts" />
namespace App {
  export class TopSniperPc {
    private urlUpdateFiltro: string = null
    private topCartasMomento: ICartaTopSniper[] = [];
    private keyStorageCartasArmazenadas: string = 'cartasArmazenadasPC';
    private keyStorageUltimaVezSalvoFiltroFull: string = 'ultimaVezSalvoPC';
    private intervaloEmMinutosStorageTempoAtualizacaoFiltroFull: number = 180; // 3 horas em minutos

    private configuracoes: {
      filtros: {
        id_filtro_especial_piloto_a: number,
        id_filtro_especial_piloto_b: number,
        id_filtro_especial_piloto_c: number,
        id_filtro_especial_piloto_d: number,
        id_filtro_piloto_inicial_A: number,
        id_filtro_piloto_inicial_B: number,
        // id_filtro_piloto_inicial_C: number,
        // id_filtro_piloto_full_A: number,
        // id_filtro_piloto_full_B: number,
      },
      piloto: {
        full: {
          lucro_unitario_minimo: number
          lucro_unitario_minimo_cartas_relacionadas: number // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
        },
        inicial: {
          raridade_minima_piloto_inicial: number
          valor_caixa_maximo: number
          preco_compra_carta_acima_de: number
          lucro_unitario_minimo: number,
          lucro_unitario_minimo_cartas_relacionadas: number, // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
          total_cartas_relacionadas_incluir_no_filtro: number
        },
        principal: {
          raridade_minima_piloto_principal: number,
          lucro_unitario_minimo: number
          lucro_unitario_minimo_cartas_relacionadas: number // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
          valor_caixa_maximo: number
          preco_compra_carta_acima_de: number
          desconsiderar_poucas_cartas_acima_de: number
          quantidade_considero_poucas_cartas: number
          quantidade_indicativa_que_a_carta_esta_caindo: number
          total_cartas_relacionadas_incluir_no_filtro: number
        }
      },
      minimo_lucro_total_carta: number,
    } = null

    constructor(urlUpdateFiltro: string) {
      this.urlUpdateFiltro = urlUpdateFiltro
      this.configuracoes = {
        filtros: {
          id_filtro_especial_piloto_a: 81689,
          id_filtro_especial_piloto_b: 81690,
          id_filtro_especial_piloto_c: 82105,
          id_filtro_especial_piloto_d: 91394,
          id_filtro_piloto_inicial_A: 92648,
          id_filtro_piloto_inicial_B: 92649,
          // id_filtro_piloto_inicial_C: null,
          // id_filtro_piloto_full_A: null,
          // id_filtro_piloto_full_B: null
        },
        piloto: {
          full: {
            lucro_unitario_minimo: 20000,
            lucro_unitario_minimo_cartas_relacionadas: 15000 // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
          },
          inicial: {
            raridade_minima_piloto_inicial: 1, // raridade minima de filtro das cartas para edição dos filtros do piloto inicial
            valor_caixa_maximo: 9000, // lucro minimo que a carta tem que dá para passar no filtro
            preco_compra_carta_acima_de: 700, // filtrar apenas cartas que são compradas acima desse valor
            lucro_unitario_minimo: 4000, // a carta tem que dá no minimo esse lucro para passar no filtro
            lucro_unitario_minimo_cartas_relacionadas: 4000, // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
            total_cartas_relacionadas_incluir_no_filtro: 0 // quantidade de cartas de mesma raridade que quero colocar junto ao filtro da carta principal
          },

          principal: {
            raridade_minima_piloto_principal: 1, // raridade minima das cartas para passar no filtro
            lucro_unitario_minimo: 30000, // a carta tem que dá no minimo esse lucro para passar no filtro
            valor_caixa_maximo: 110000, // cria filtros com o caixa limite informado.
            preco_compra_carta_acima_de: 10000, // filtrar apenas cartas que são compradas acima desse valor
            desconsiderar_poucas_cartas_acima_de: 100000, // desconsidear cartas que tem poucas unidades e são compradas acima desse valor
            quantidade_considero_poucas_cartas: 2, // quantidade de cartas que considero poucas
            quantidade_indicativa_que_a_carta_esta_caindo: 1, // quantidade de cartas que indica que a carta está caindo no momento
            lucro_unitario_minimo_cartas_relacionadas: 20000, // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
            total_cartas_relacionadas_incluir_no_filtro: 0
          }
        },

        minimo_lucro_total_carta: 4000, // lucro geral obtido com a carta para poder entrar no topCartas
      };
    }

    public async validarRegrasUrlCarregada(urlAtual: string): Promise<string> {
      const url = new URL(urlAtual);

      // Verifica se o parâmetro 'id_plataforma' existe e se é diferente de '3'
      if (!url.searchParams.has('id_plataforma') || url.searchParams.get('id_plataforma') !== '3') {
        // Define o parâmetro 'id_plataforma' como '3'
        url.searchParams.set('id_plataforma', '3');
        return url.toString();
      }

      return null;
    }

    public iniciarRecarregamento() {
      window.location.replace('https://futsniperweb.com.br/tyfdyagg5445drdff?id_plataforma=3')
    }

    /**
   * Condição para as cartas certas que considero importantes está em minha análise
   * @param objTopCarta
   */
    public condicaoTopCartasImportantes(objTopCarta: ICartaTopSniper) {
      if (objTopCarta.lucro > this.configuracoes.minimo_lucro_total_carta) {
        this.topCartasMomento.push(objTopCarta)
      }
    }

    public prepararTopCartas() {
      this.topCartasMomento.sort((a: any, b: any) => b.lucro - a.lucro);
      TopSniperUtil.logTopSniper('TOP_CARTAS_PC', this.topCartasMomento);
      this.iniciandoAnaliseTopcartas();
    }

    private iniciandoAnaliseTopcartas() {
      // valor é o valor de compra
      // preco é o preço de venda
      // total é quantidade de cartas total encontrada
      // quantidade_mais é a quantidade de cartas encontrada a mais da ultima vez que filtrei
      // lucro_unitario é quanto de lucro a carta me dará apos ser vendida

      this.metodoTopCartasPilotoPrincipal()
      this.metodoTopCartasOuroPilotoSecundarioInicial()
    }

    private getCartasInteresseFiltrosPrincipais(topCartasMomento: ICartaTopSniper[] = this.topCartasMomento, quantidadeAmais: number = this.configuracoes.piloto.principal.quantidade_indicativa_que_a_carta_esta_caindo): ICartaTopSniper[] {
      return topCartasMomento.filter((ele: any) => {
        let naoConsiderarCartasDeValorAltoComPoucaQuantidade = !(ele.valor >= this.configuracoes.piloto.principal.desconsiderar_poucas_cartas_acima_de
          && ele.total < this.configuracoes.piloto.principal.quantidade_considero_poucas_cartas);

        return ele.quantidade_mais >= quantidadeAmais
          && ele.raridade.id >= this.configuracoes.piloto.principal.raridade_minima_piloto_principal
          && ele.lucro_unitario && ele.lucro_unitario >= this.configuracoes.piloto.principal.lucro_unitario_minimo
          && ele.valor >= this.configuracoes.piloto.principal.preco_compra_carta_acima_de
          && ele.valor <= this.configuracoes.piloto.principal.valor_caixa_maximo
          && naoConsiderarCartasDeValorAltoComPoucaQuantidade;
      });
    }

    private getCartasInteresseFiltrosPrincipaisSobra(topCartasMomento: ICartaTopSniper[] = this.topCartasMomento): ICartaTopSniper[] {
      return topCartasMomento.filter((ele: any) => {
        return ele.quantidade_mais < this.configuracoes.piloto.principal.quantidade_indicativa_que_a_carta_esta_caindo
          && ele.total >= this.configuracoes.piloto.principal.quantidade_considero_poucas_cartas
          && ele.raridade.id >= this.configuracoes.piloto.principal.raridade_minima_piloto_principal
          && ele.lucro_unitario && ele.lucro_unitario >= this.configuracoes.piloto.principal.lucro_unitario_minimo
          && ele.valor >= this.configuracoes.piloto.principal.preco_compra_carta_acima_de
          && ele.valor <= this.configuracoes.piloto.principal.valor_caixa_maximo;
      });
    }

    public metodoTopCartasPilotoPrincipal() {
      let cartasEspeciaisPilotoPlus: ICartaTopSniper[] = this.getCartasInteresseFiltrosPrincipais()
      let cartasEspeciaisPilotoSobra: ICartaTopSniper[] = this.getCartasInteresseFiltrosPrincipaisSobra()

      TopSniperUtil.logTopSniper("PILOTO PRINCIPAL PC", cartasEspeciaisPilotoPlus);
      TopSniperUtil.logTopSniper("PILOTO SOBRA PC", cartasEspeciaisPilotoSobra);

      if (cartasEspeciaisPilotoPlus.length) {
        TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_especial_piloto_a, cartasEspeciaisPilotoPlus[0], cartasEspeciaisPilotoPlus,
          this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
          this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
          this.urlUpdateFiltro);

        if (cartasEspeciaisPilotoPlus.length <= 1 && cartasEspeciaisPilotoSobra.length) {
          cartasEspeciaisPilotoPlus = cartasEspeciaisPilotoPlus.concat(cartasEspeciaisPilotoSobra);
        }

        if (cartasEspeciaisPilotoPlus.length > 1) {
          TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_especial_piloto_b, cartasEspeciaisPilotoPlus[1], cartasEspeciaisPilotoPlus,
            this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro);
        }

        if (cartasEspeciaisPilotoPlus.length <= 2 && cartasEspeciaisPilotoSobra.length) {
          cartasEspeciaisPilotoPlus = cartasEspeciaisPilotoPlus.concat(cartasEspeciaisPilotoSobra);
        }

        if (cartasEspeciaisPilotoPlus.length > 2) {
          TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_especial_piloto_c, cartasEspeciaisPilotoPlus[2], cartasEspeciaisPilotoPlus,
            this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro);
        }

        if (cartasEspeciaisPilotoPlus.length > 3) {
          TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_especial_piloto_d, cartasEspeciaisPilotoPlus[3], cartasEspeciaisPilotoPlus,
            this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro);
        }
      }

      TopSniperUtil.logTopSniper("PILOTO PRINCIPAL FINAL PC", cartasEspeciaisPilotoPlus);
    }

    private getCartasInteresseFiltrosIniciais(topCartasMomento: ICartaTopSniper[] = this.topCartasMomento, quantidadeAmais: number = 1): ICartaTopSniper[] {
      return topCartasMomento.filter((ele: any) => {
        return ele.quantidade_mais >= quantidadeAmais
          && ele.lucro_unitario && ele.lucro_unitario >= this.configuracoes.piloto.inicial.lucro_unitario_minimo
          && ele.valor >= this.configuracoes.piloto.inicial.preco_compra_carta_acima_de
          && ele.valor <= this.configuracoes.piloto.inicial.valor_caixa_maximo;
      });
    }

    private metodoTopCartasOuroPilotoSecundarioInicial() {
      let cartasOuroPiloto = this.getCartasInteresseFiltrosIniciais()
      TopSniperUtil.logTopSniper("PILOTO INICIAL PC", cartasOuroPiloto);

      // salvando até 4 filtros
      if (cartasOuroPiloto.length) {
        TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_piloto_inicial_A, cartasOuroPiloto[0], cartasOuroPiloto,
          this.configuracoes.piloto.inicial.lucro_unitario_minimo_cartas_relacionadas,
          this.configuracoes.piloto.inicial.total_cartas_relacionadas_incluir_no_filtro,
          this.urlUpdateFiltro
        );

        if (cartasOuroPiloto.length > 1) {
          TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_piloto_inicial_B, cartasOuroPiloto[1], cartasOuroPiloto,
            this.configuracoes.piloto.inicial.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.inicial.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro
          );
        }

        // if (cartasOuroPiloto.length > 2) {
        //   TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_piloto_inicial_C, cartasOuroPiloto[2], cartasOuroPiloto, this.configuracoes.piloto.inicial.lucro_unitario_minimo_cartas_relacionadas, this.urlUpdateFiltro);
        // }

        // if (cartasOuroPiloto.length > 3) {
        //   TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_piloto_inicial_D, cartasOuroPiloto[3], cartasOuroPiloto, this.configuracoes.piloto.inicial.lucro_unitario_minimo_cartas_relacionadas, this.urlUpdateFiltro);
        // }
      }

      TopSniperUtil.logTopSniper("PILOTO INICIAL FINAL PC", cartasOuroPiloto);
    }
  }
}
